/* =============================================================
   UNSAVED-CHANGES GUARD
   =============================================================
   Every record form is a full page, and a full page does not make
   losing work hard the way a dialog did -- one tap on the nav and
   the edits are gone. So each form asks before leaving with
   changes, both for in-app navigation and for a reload or closed
   tab.

   window.confirm rather than the app's Modal because a route
   guard has to answer synchronously. While `saving` the guard
   stands down: the form navigates away itself once the write
   lands, and asking then would be about changes just saved.
   ============================================================= */

import { onMounted, onUnmounted, type Ref } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'

export function useUnsavedGuard(dirty: Ref<boolean>, saving: Ref<boolean>): void {
  onBeforeRouteLeave(() => {
    if (!dirty.value || saving.value) return true
    return window.confirm('Leave without saving? Your changes will be lost.')
  })

  function onBeforeUnload(event: BeforeUnloadEvent): void {
    if (dirty.value) event.preventDefault()
  }
  onMounted(() => window.addEventListener('beforeunload', onBeforeUnload))
  onUnmounted(() => window.removeEventListener('beforeunload', onBeforeUnload))
}
